<script context="module">
  import Outside from "@layouts/Outside.svelte"

  export const layout = Outside

  const errorMessages = Object.freeze({
    accountRequiresCertificate:
      "This account requires additional setup to share collections. Please contact the person who sent you this link and ask them to sign in to their SideDoor account to complete setup.",
    default:
      "Something went wrong, please try again later. If this error persists, contact us at info@onsidedoor.com for assistance.",
  })
</script>

<script>
  import Combomark from "@components/logos/SideDoor/Combomark.svelte"
  import widont from "@actions/use-widont"

  export let errorHttpStatusCode
  export let errorCode

  $: errorMessage = errorMessages[errorCode] || errorMessages.default
</script>

<div class="flex justify-center">
  <div class="bg-beige-100 mx-2 max-w-md p-6 py-8 flex flex-col items-center">
    <div class="w-[220px] max-w-full mb-6">
      <Combomark />
    </div>

    <h3 class="font-normal text-xl mb-2">Error processing request ({errorHttpStatusCode})</h3>

    <p use:widont class="text-center">{errorMessage}</p>
  </div>
</div>
